export const MAP_SETTINGS_MAP_STYLES_SET_SATELLITE = 'MAP_SETTINGS_MAP_STYLES/SET_SATELLITE';
export const MAP_SETTINGS_MAP_STYLES_CHANGE = 'MAP_SETTINGS_MAP_STYLES/CHANGE';
export const MAP_SETTINGS_MAP_STYLES_THEME_CHANGE = 'MAP_SETTINGS_MAP_STYLES/THEME_CHANGE';
export const MAP_SETTINGS_MAP_STYLES_STANDARD_SLIDERS_CHANGE = 'MAP_SETTINGS_MAP_STYLES/STANDARD_SLIDERS_CHANGE';
export const MAP_SETTINGS_MAP_STYLES_STANDARD_COLORS_CHANGE = 'MAP_SETTINGS_MAP_STYLES/STANDARD_COLORS_CHANGE';
